import { vehicleApi } from "@/core/apis";

// getter types
export const VEHICLE_BASE_DATA = "vehicleBaseData";

// action types
export const GET_VEHICLE_BASE_DATA = "getVehicleBaseData";

// mutation types
const SET_VEHICLE_BASE_DATA = "setVehicleBaseData";

const state = {
  vehicleBaseData: []
};

const getters = {
  [VEHICLE_BASE_DATA](state) {
    return state.vehicleBaseData;
  }
};

const actions = {
  [GET_VEHICLE_BASE_DATA](context) {
    return new Promise(resolve => {
      vehicleApi.getVehicleEditorInitData().then(response => {
        context.commit(SET_VEHICLE_BASE_DATA, response);

        resolve();
      });
    });
  }
};

const mutations = {
  [SET_VEHICLE_BASE_DATA](state, vehicleBaseData) {
    state.vehicleBaseData = vehicleBaseData;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
